// A screen holding work that leaving would lose sets this; it says whether leaving may go ahead
let leaveGuard: (() => boolean) | undefined;

export function setLeaveGuard(guard: (() => boolean) | undefined) {
  leaveGuard = guard;
}

export function viewPath(path: string) {
  if (leaveGuard && !leaveGuard()) return;
  window.dispatchEvent(
    new CustomEvent('view-path', {
      detail: path,
      bubbles: true,
      composed: true,
    }),
  );
}
